import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { declarationsForApp, declaredComponentReferenceKeys }
  from "%/dynamic-component-editor/helpers/declared-app-option-keys";

const mintedByKey = new Map();

export { declarationsForApp, declaredComponentReferenceKeys };

function classNameFor(optionKey) {
  return optionKey
      .split("-")
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join("");
}

function mint(appName, optionKey) {
  const declarationOf = () => declarationsForApp(appName)[optionKey] ?? {};
  const name = classNameFor(optionKey);
  return {
    [name]: class extends BaseOption {
      static get label() {
        return declarationOf().label ?? optionKey;
      }

      static get defaultValue() {
        return declarationOf().default ?? 0;
      }

      static convertConfigValueToCompiledValue(configValue, themeId, themeMode = "inherit") {
        if (!configValue || typeof configValue !== "object") {
          return configValue;
        }
        if (!("source" in configValue) || !("value" in configValue)) {
          return configValue;
        }
        return BaseOption.getColorValue(configValue, null, null, themeId, themeMode);
      }

      static get userInterfaceComponent() {
        const declaration = declarationOf();
        const toolName = declaration.inspectorTool;
        return {
          label: declaration.label ?? optionKey,
          component: toolName && inspectorTools[toolName]
            ? inspectorTools[toolName]
            : inspectorTools.REFERENCED_COMPONENT_PICKER,
          props: { appName, ...declaration.toolProps ?? {} },
        };
      }
    },
  }[name];
}

export function declaredAppOption(appName, optionKey) {
  if (mintedByKey.has(optionKey)) {
    return mintedByKey.get(optionKey);
  }
  const Minted = mint(appName, optionKey);
  mintedByKey.set(optionKey, Minted);
  return Minted;
}

export function declaredAppOptions(appName, optionKeys) {
  return optionKeys.map(optionKey => declaredAppOption(appName, optionKey));
}
